import { useTranslations } from "next-intl";

import Button from "~/components/common/button";
import LinkWrapper from "~/components/common/link-wrapper";

import Dialog from "../../common/dialog";
import Icon from "../../common/icon";
import styles from "./cancel-order-dialog.module.scss";

type Props = {
  isOpen?: boolean;
  isPaid?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  successfullyCancelled: boolean;
  timeoutCancel?: boolean;
  isLoading?: boolean;
};

export default function CancelOrderDialog(props: Props) {
  const t = useTranslations();

  return (
    <Dialog
      isOpen={props.isOpen}
      title={
        <>
          <Icon name="alert" />
          <span>{t("generic.orderCancellation")}</span>
        </>
      }
      onClose={props.onClose}
      customStyles={styles}
    >
      {props.successfullyCancelled ? (
        <>
          <p className={styles.text}>
            {props.isPaid ? t("generic.orderCancellationSuccess") : t("generic.orderCancellationWithoutPaymentSuccess")}
          </p>
          <LinkWrapper lookAsButton="primary" href={"/"} style={{ textAlign: "center" }}>
            {t("generic.continueshopping")}
          </LinkWrapper>
        </>
      ) : props.timeoutCancel ? (
        <p>{t("generic.cancelPeriodExpired")}</p>
      ) : (
        <>
          <p className={styles.text}>{t("generic.orderCancellationConfirm")}</p>
          <div className={styles.lineButtons}>
            <Button variant="primary" type="button" onClick={props.onClose}>
              {t("generic.confirmCancelNo")}
            </Button>
            <Button variant="secondary" type="button" onClick={props.onSubmit} loading={props.isLoading}>
              {t("generic.confirmCancelYes")}
            </Button>
          </div>
        </>
      )}
    </Dialog>
  );
}
